export default __webpack_public_path__ + "static/media/checkbox-unchecked.07f28c9b.svg";